import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatFileSize(bytes: number): string {
    if (bytes === 0) return '0 Bytes';

    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return `${parseFloat((bytes / Math.pow(k, i)).toFixed(2))} ${sizes[i]}`;
}

/**
 * Formats a person's name for display, handling name and lastName fields
 */
export function formatPersonName(person: { name?: string; lastName?: string }) {
  // If we have both name and lastName, combine them
  if (person.name && person.lastName) {
    return `${person.name} ${person.lastName}`;
  }
  
  // If we only have name, try to split it intelligently if it contains multiple words
  if (person.name) {
    const nameParts = person.name.trim().split(' ');
    if (nameParts.length >= 2) {
      // Show first name and last name
      return `${nameParts[0]} ${nameParts[nameParts.length - 1]}`;
    }
    return person.name;
  }
  
  // If we only have lastName
  if (person.lastName) {
    return person.lastName;
  }
  
  return 'Sin nombre';
}

/**
 * Gets the display name for tooltips (name lastName format)
 */
export function getTooltipName(person: { name?: string; lastName?: string }) {
  // If we have both name and lastName, combine them
  if (person.name && person.lastName) {
    return `${person.name} ${person.lastName}`;
  }
  
  // If we only have name, return it as is
  if (person.name) {
    return person.name;
  }
  
  // If we only have lastName
  if (person.lastName) {
    return person.lastName;
  }
  
  return 'Sin nombre';
}
